import { configureStore, combineReducers } from "@reduxjs/toolkit";

import typeCard from "../slices/cardType";
import getQrLinkSlice from "../slices/getQrLinkSlice";
import qrSettings from "../slices/qrSettings";
import togglePrewievQr from "../slices/togglePrewievQr";
import qrFrames from "../slices/qrFrames";
import qrText from "../slices/qrTextSettings";
import navigation from "../slices/navigation";
import categories from "../slices/selectCategories";
import preloader from "../slices/preloader";
import forceСreate from "../slices/forceСreate";
import saveValue from "../slices/saveValue";
import changeLang from "../slices/changeLang";
import identification from "../slices/identification";
import qrTemplates from "../slices/qrTemplates";
import linksBuilder from "../slices/linksBuilder";
import qrOverlay from "../slices/qrOverlay";
import modals from "../slices/modals";
import customizeQr from "../slices/customizeQr";
import multiUrl from "../slices/multiUrl";
import preMadeTemplates from "../slices/preMadeTemplates";
import qrOptions from "../slices/qrOptions";
import titleSlice from '../slices/templateTitleSlice';
import booking from "../slices/booking";


const rootReducer = combineReducers({
  typeCard,
  getQrLinkSlice,
  qrSettings,
  togglePrewievQr,
  qrFrames,
  qrText,
  navigation,
  categories,
  preloader,
  forceСreate,
  saveValue,
  changeLang,
  identification,
  qrTemplates,
  linksBuilder,
  qrOverlay,
  modals,
  customizeQr,
  multiUrl,
  preMadeTemplates,
  qrOptions,
  titleSlice,
  booking,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
